import { z } from 'zod';
import { PassFailWithNull } from '@/utils/common';

export const baseMarch20KmPerformanceFormSchema = z.object({
    timingSec: z.number().min(0).nullable().optional(),
    result: z.enum(PassFailWithNull).nullable().optional(),
    date: z.date(),
});

export const createMarch20KmPerformanceFormSchema = baseMarch20KmPerformanceFormSchema
    .extend({
        userId: z.string().min(1, { message: 'Trainee is required' }),
        assessmentRunId: z.string().nullable().optional(),
        isTiedToAssessmentRun: z.boolean(),
    })
    .refine(data => !(data.isTiedToAssessmentRun && !data.assessmentRunId), {
        message: 'Assessment run is required when tying to an assessment run',
        path: ['assessmentRunId'],
    });

export type CreateMarch20KmPerformanceFormData = z.infer<typeof createMarch20KmPerformanceFormSchema>;

export type EditMarch20KmPerformanceFormData = z.infer<typeof baseMarch20KmPerformanceFormSchema> & {
    timingSecMinutes?: number | null;
    timingSecHours?: number | null;
    assessmentRunId?: string | null;
    isTiedToAssessmentRun?: boolean;
};

export const march20KmPerformanceDefaultFormValues: CreateMarch20KmPerformanceFormData = {
    timingSec: null,
    result: null,
    date: new Date(),
    assessmentRunId: null,
    isTiedToAssessmentRun: false,
    userId: '',
};
